import { render, staticRenderFns } from "./extendedFullreports.vue?vue&type=template&id=86e3ac8a&scoped=true"
import script from "./extendedFullreports.vue?vue&type=script&lang=js"
export * from "./extendedFullreports.vue?vue&type=script&lang=js"
import style0 from "./extendedFullreports.vue?vue&type=style&index=0&id=86e3ac8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e3ac8a",
  null
  
)

export default component.exports